module.exports = __webpack_public_path__ + "./b8b555c448df5cb83f566edddfd4bb18-icon-service-default-medium@2x.png";


//////////////////
// WEBPACK FOOTER
// ./plugins/services/src/img/icon-service-default-medium@2x.png
// module id = 1083
// module chunks = 0